import { type FC } from "react";
import { useParams } from "react-router-dom";

import { Button } from "@snapchat/snap-design-system";

import { type AbsoluteRoute, type RouteParams } from "../../../core/routes";
import { useLensSubmissionRoutesV3 } from "../../../core/routes/hooks";
import { type SurfaceType } from "../../../gql-generated/types";
import { Flexbox } from "../../../shared/components";

import { ButtonAddIcon, ButtonReplayIcon, updateAnExistingLensButton } from "./SelectLensFolderPage.styles";
import { SubmitLens, UpdateExistingLens } from "./messages.generated";

interface SelectLensFolderActionsProps {
    selectedLensFolderId: string;
    surfaceType: readonly SurfaceType[];
    isDisabled?: boolean;
}

export const SelectLensFolderActions: FC<SelectLensFolderActionsProps> = ({
    selectedLensFolderId,
    surfaceType,
    isDisabled = false,
}) => {
    const { submissionId = "" } = useParams<RouteParams[AbsoluteRoute.SUBMIT_LENS_FOLDER_SELECT]>();

    const { goToLensCreate, goToLensSelect } = useLensSubmissionRoutesV3();

    return (
        <Flexbox flexDirection="row-reverse">
            <Button
                type="primary"
                isDisabled={!selectedLensFolderId || isDisabled}
                onClick={() => {
                    goToLensCreate(submissionId, selectedLensFolderId, surfaceType);
                }}
            >
                <ButtonAddIcon fill="#FFFFFF" />
                <SubmitLens />
            </Button>
            <Button
                className={updateAnExistingLensButton}
                isDisabled={isDisabled}
                onClick={() => {
                    goToLensSelect(submissionId, selectedLensFolderId, surfaceType);
                }}
            >
                <ButtonReplayIcon />
                <UpdateExistingLens />
            </Button>
        </Flexbox>
    );
};
